import { render } from "./StudentNumCharts.vue?vue&type=template&id=e5268000&scoped=true"
import script from "./StudentNumCharts.vue?vue&type=script&lang=js"
export * from "./StudentNumCharts.vue?vue&type=script&lang=js"

import "./StudentNumCharts.vue?vue&type=style&index=0&id=e5268000&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5268000"]])

export default __exports__